<template>
  <div class="info-overview">
    <el-row :gutter="16">
      <el-col :span="12" :xs="24" :md="12" :sm="24">
        <div class="info-panel-wrap">
          <section id="shareContent" class="info-panel">
            <div class="panel-head">
              <div class="panel-title">
                <span class="panel-dot"></span>
                <span>基本信息(内)</span>
              </div>
              <el-button
                v-if="isShow"
                type="primary"
                size="mini"
                icon="el-icon-phone-outline"
                @click="handleNotice">
                通知报名人
              </el-button>
            </div>

            <div class="info-grid">
              <div class="info-item">
                <label>项目名称</label>
                <span>{{ infoData.name || '暂无' }}</span>
              </div>
              <div v-if="infoData.type === 1" class="info-item">
                <label>意向达人</label>
                <span v-if="infoData?.intentions?.length > 0">
                  <span v-for="i in infoData.intentions" :key="i.id" class="text-chip">{{ i?.nickname || '' }}</span>
                </span>
                <span v-else>暂无意向达人</span>
              </div>
              <div class="info-item">
                <label>品牌</label>
                <span>{{ infoData.brand || '暂无' }}</span>
                <em>是否寄回：{{ infoData.is_send_back == 1 ? '是' : '否' }}</em>
              </div>
              <div class="info-item">
                <label>所属集团</label>
                <span>{{ infoData?.group?.display_name || '暂无' }}</span>
              </div>
              <div class="info-item">
                <label>品牌背书</label>
                <span>{{ infoData?.brand_intro || '暂无' }}</span>
              </div>
              <div class="info-item">
                <label>合作平台</label>
                <div class="platform-list">
                  <span
                    v-for="i in infoPlatforms"
                    :key="i.value"
                    class="platform-chip"
                    :style="getPlatformStyle(i)">
                    <span class="platform-dot" :style="{ backgroundColor: 'var(--platform-color)' }"></span>
                    {{ i.name }}
                  </span>
                  <span v-if="!infoPlatforms.length">暂无</span>
                </div>
              </div>
              <div v-if="infoData.type === 1" class="info-item">
                <label>合作形式</label>
                <span>{{ infoData?.coop?.display_name || '暂无' }}</span>
              </div>
              <div class="info-item">
                <label>是否平台下单</label>
                <span>{{ infoData.is_platform_pay === 1 ? '是' : '否' }}</span>
              </div>
              <div class="info-item">
                <label>特别激励政策</label>
                <span>{{ Number(infoData?.is_policy) === 1 ? '有' : '无' }} / {{ infoData.policy || '暂无政策' }}</span>
              </div>
              <div class="info-item">
                <label>授权平台</label>
                <span>{{ formatArrayText(infoData?.auth_platform_alias) }}</span>
              </div>
              <div class="info-item">
                <label>期望档期</label>
                <span>{{ formatDateRange(infoData.expect_start, infoData.except_end) }}</span>
              </div>
              <div class="info-item">
                <label>直播明细</label>
                <span>{{ infoData.live_detail || '暂无' }}</span>
              </div>
              <div class="info-item">
                <label>其他要求</label>
                <span>{{ infoData.other_desc || '暂无' }}</span>
              </div>
              <div class="info-item">
                <label>报名时间</label>
                <span>{{ formatDateRange(infoData.apply_start, infoData.apply_end) }}</span>
              </div>
              <div class="info-item">
                <label>创建人</label>
                <span>{{ infoData?.create_user?.nickname || '暂无' }}</span>
              </div>
            </div>

            <div class="notice-line">报名时不备注默认都接受</div>

            <div class="product-collapse">
              <div class="collapse-head" @click="productExpanded = !productExpanded">
                <div class="panel-title small">
                  <span class="panel-dot muted-dot"></span>
                  <span>产品信息</span>
                  <span class="product-count">{{ infoData.product_list?.length || 0 }}个</span>
                </div>
                <i class="el-icon-arrow-right collapse-arrow" :class="{ open: productExpanded }"></i>
              </div>
              <div v-show="productExpanded" class="product-list">
                <div v-for="product in infoData.product_list" :key="product.id" class="product-card">
                  <div class="product-main">
                    <div class="product-title">{{ product.product || '暂无产品名称' }}</div>
                    <div class="product-grid">
                      <div class="product-item">
                        <label>是否保量</label>
                        <span>{{ product.is_quantity === 1 ? '是' : '否' }}</span>
                        <em v-if="product.is_quantity === 1">费比：{{ product.qty_policy || '-' }}，直播佣金：{{ product.live_cmn || '-' }}</em>
                      </div>
                      <div v-if="infoData.type === 1" class="product-item">
                        <label>挂车佣金</label>
                        <span>{{ product.is_cart === 1 ? '是' : '否' }}</span>
                        <em v-if="product.is_cart === 1">佣金：{{ product.cart_rate || '-' }}，机制：{{ product.cart_mechanism || '-' }}</em>
                      </div>
                      <div class="product-item">
                        <label>全网统一机制</label>
                        <span>{{ product.unify === 1 ? '是' : '否' }}</span>
                        <em v-if="product.unify === 2">特殊机制：{{ product.special_remark || '-' }}</em>
                      </div>
                      <div class="product-item">
                        <label>是否有签独家</label>
                        <span>{{ product.exclusive === 1 ? '是' : '否' }}</span>
                        <em v-if="product.exclusive === 1">独家机制：{{ product.other_activity || '-' }}</em>
                      </div>
                      <div class="product-item">
                        <label>保价一个月</label>
                        <span>{{ product.support_value === 1 ? '是' : '否' }}</span>
                      </div>
                      <div v-if="product.inquiry_project_attachment?.length" class="product-item wide">
                        <label>产品附件</label>
                        <span>
                          <a
                            v-for="file in product.inquiry_project_attachment"
                            :key="file.id"
                            class="file-link"
                            :href="file.full_path"
                            target="_blank">
                            <i class="el-icon-download"></i>
                            {{ file.original || '附件下载' }}
                          </a>
                        </span>
                      </div>
                      <div class="product-item wide">
                        <label>产品卖点</label>
                        <span>{{ product.intro || '暂无' }}</span>
                      </div>
                      <div class="product-item wide">
                        <label>直播机制</label>
                        <span>{{ product.live_mec || '暂无' }}</span>
                      </div>
                    </div>
                  </div>
                  <img v-if="product.cover_url" class="product-cover" :src="product.cover_url" fit="contain" />
                </div>
                <div v-if="!infoData.product_list?.length" class="empty-product">暂无产品信息</div>
              </div>
            </div>
          </section>

          <div class="panel-actions">
            <el-button
              size="mini"
              type="primary"
              plain
              icon="el-icon-document-copy"
              v-clipboard:copy="downFrom.shareContentData"
              v-clipboard:error="onError"
              v-clipboard:success="onCopyInfo">
              复制文本
            </el-button>
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-view"
              @click="clickShare('shareContent')">
              预览
            </el-button>
          </div>
        </div>
      </el-col>

      <el-col :span="12" :xs="24" :md="12" :sm="24">
        <div class="info-panel-wrap">
          <section id="share2Content" class="info-panel">
            <div class="panel-head">
              <div class="panel-title">
                <span class="panel-dot"></span>
                <span>基本信息(外)</span>
              </div>
            </div>
            <div class="info-grid">
              <div class="info-item">
                <label>贵司名称</label>
                <span>{{ infoData.brand || '暂无' }}</span>
              </div>
              <div class="info-item">
                <label>品牌</label>
                <span>{{ infoData.brand || '暂无' }}</span>
                <em>是否寄回：{{ infoData.is_send_back == 1 ? '是' : '否' }}</em>
              </div>
              <div class="info-item">
                <label>所属集团</label>
                <span>{{ infoData?.group?.display_name || '暂无' }}</span>
              </div>
              <div class="info-item">
                <label>品牌背书</label>
                <span>{{ infoData?.brand_intro || '暂无' }}</span>
              </div>
              <div class="info-item">
                <label>合作平台</label>
                <div class="platform-list">
                  <span
                    v-for="i in infoPlatforms"
                    :key="i.value"
                    class="platform-chip"
                    :style="getPlatformStyle(i)">
                    <span class="platform-dot" :style="{ backgroundColor: 'var(--platform-color)' }"></span>
                    {{ i.name }}
                  </span>
                  <span v-if="!infoPlatforms.length">暂无</span>
                </div>
              </div>
              <div v-if="infoData.type === 1" class="info-item">
                <label>合作形式</label>
                <span>{{ infoData?.coop?.display_name || '暂无' }}</span>
              </div>
              <div class="info-item">
                <label>产品名称</label>
                <span>{{ productNames }}</span>
              </div>
              <div v-if="intro !== ''" class="info-item">
                <label>产品资料</label>
                <span v-html="intro"></span>
              </div>
              <div class="info-item">
                <label>期望档期</label>
                <span>{{ formatDateRange(infoData.expect_start, infoData.except_end) }}</span>
              </div>
              <div class="info-item">
                <label>直播明细</label>
                <span>{{ infoData.live_detail || '暂无' }}</span>
              </div>
              <div class="info-item">
                <label>其他要求</label>
                <span>{{ infoData.other_desc || '暂无' }}</span>
              </div>
            </div>
            <div class="notice-line">报名时不备注默认都接受</div>
          </section>

          <div class="panel-actions">
            <el-button
              size="mini"
              type="primary"
              plain
              icon="el-icon-document-copy"
              v-clipboard:copy="downFrom.share2ContentData"
              v-clipboard:error="onError"
              v-clipboard:success="onCopyInfo">
              复制文本
            </el-button>
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-view"
              @click="clickShare('share2Content')">
              预览
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="`分享信息预览`" :visible.sync="dialogImageVisible" @close="closefn" center width="50%">
      <div>
        <el-row>
          <ul>
            <li>
              <a @click="downs" href="#" class="float-right mb-10"><i class="el-icon-download" style="margin-right:4px"></i> 点击下载【{{
                btnTitle
              }}】到本地</a>
            </li>
          </ul>
        </el-row>

        <el-image
          :src="imgUrl"
          alt="档期"
          fit="fill"
          style="width: auto; height: auto"></el-image>

        <el-row>
          <el-col :span="24">
            <el-button @click="downs" size="small" class="w-full mt-20" type="primary" icon="el-icon-download">点击下载【{{ btnTitle }}】到本地
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'

export default {
  name: 'infoCard',
  data() {
    return {
      infoData: {},
      //已有平台
      infoPlatforms: [],
      projectId: '',
      copyInfo: '请重试',
      copyData: '请重试',
      intro: '',
      other_desc: '',
      live_detail: '',
      dialogTitle: '',
      dialogImageVisible: false,
      clickfn: false,
      btnTitle: '基本信息',
      imgUrl: null, //图片链接
      productExpanded: false,
      downFrom: {
        inner:[
          {field: 'name', label:'项目名称'},
          {field: 'intentions', label:'意向达人'},
          {field: 'brand', label:'品牌'},
          {field: 'group', label:'所属集团'},
          {field: 'brand_intro', label:'品牌背书'},
          {field: 'infoPlatforms', label:'合作平台'},
          {field: 'coop', label:'合作形式'},
          {field: 'is_platform_pay', label:'是否平台下单'},
          {field: 'is_policy', label:'有无特别激励政策'},
          {field: 'auth_platform_alias', label:'授权平台'},
          {field: 'schedule_date', label:'期望档期'},
          {field: 'live_detail', label:'直播明细'},
          {field: 'other_desc', label:'其他要求'},
          {field: 'enroll_date', label:'报名时间'},
          {field: 'create_user', label:'创建人'},
        ],
        product:[
          {field: 'product', label:'产品名称'},
          {field: 'is_quantity', label:'是否保量'},
          {field: 'is_cart', label:'挂车佣金'},
          {field: 'unify', label:'是否全网统一机制'},
          {field: 'exclusive', label:'是否有签独家'},
          {field: 'other_activity', label:'独家机制'},
          {field: 'support_value', label:'是否可签保价一个月'},
          {field: 'intro', label:'产品卖点'},
          {field: 'live_mec', label:'直播机制'},
        ],
        outside:[
          {field: 'company', label:'贵司名称'},
          {field: 'brand', label:'品牌'},
          {field: 'group', label:'所属集团'},
          {field: 'brand_intro', label:'品牌背书'},
          {field: 'infoPlatforms', label:'合作平台'},
          {field: 'coop', label:'合作形式'},
          {field: 'product_list', label:'产品名称'},
          {field: 'intro', label:'产品资料'},
          {field: 'schedule_date', label:'期望档期'},
          {field: 'live_detail', label:'直播明细'},
          {field: 'other_desc', label:'其他要求'},
        ],
        list: [],
        shareContentData: '',
        share2ContentData: '',
      }
    }
  },
  props:{
    isShow: {
      type: Boolean,
      default: true
    },
  },
  components: {},
  computed: {
    productNames() {
      if (!this.infoData.product_list || this.infoData.product_list.length === 0) {
        return '暂无'
      }
      return this.infoData.product_list.map(item => item.product).filter(Boolean).join('、') || '暂无'
    }
  },
  methods: {
    onCopyInfo() {
      this.$message({
        message: '复制成功！',
        type: 'success'
      })
    },
    onError() {
      this.$message({
        message: '复制失败！',
        type: 'error'
      })
    },
    async getInfo() {
      const { info } = await this.$api.infoInquiryProject({ id: this.projectId })
      const { list } = await this.$api.getCategoryListByIdentify(`inquiry-platforms`)
      const platforms = list

      // 收集打包平台（name === 'package' 节点的 children code 集合）
      const packageCodes = []
      platforms.forEach((i) => {
        if (i.name === 'package') {
          (i.children || []).forEach((v) => {
            packageCodes.push(v.name)
          })
        }
      })

      platforms.forEach((i) => {
        if (i.name === 'package') {
          i.children.forEach((v) => {
            platforms.push(v)
          })
        }
      })
      this.$nextTick(() => {
        const mapNewArray = []
        for (const i in platforms) {
          info.platforms.forEach((item) => {
            if (item !== 'package' && item === platforms[i].name) {
              mapNewArray.push({
                name: platforms[i].display_name,
                value: item,
                color: this.getPlatformThemeColor(platforms[i])
              })
            }
          })
        }
        this.infoPlatforms = mapNewArray
        this.infoData = info
        this.$emit('infoPlatform', this.infoPlatforms)
        this.$emit('packagePlatforms', packageCodes)
        this.$emit('infoName', info.name || '')
        this.$emit('update:infoStatus', {
          status: info.status,
          is_apply: info.is_apply,
          note: info.other_desc,
          coop_id: info.coop_id,
        })
        // 复制基本信息(内)
        this.copyDataRow('shareContent')
        // 复制基本信息(外)
        this.copyDataRow('share2ContentData')
      })

    },
    formatArrayText(list) {
      if (!Array.isArray(list) || list.length === 0) {
        return '暂无'
      }
      return list.filter(Boolean).join('、') || '暂无'
    },
    formatDateRange(start, end) {
      const startText = start ? String(start).slice(0, 10) : ''
      const endText = end ? String(end).slice(0, 10) : ''
      if (!startText && !endText) {
        return '暂无'
      }
      return `${startText || '-'} 至 ${endText || '-'}`
    },
    getPlatformThemeColor(platform) {
      const color = platform.color || platform.color_val || platform.color_value || platform.theme_color
      if (color) {
        return color
      }
      const platformKey = String(platform.value || platform.name || platform.display_name || '').toLowerCase()
      const colorMap = {
        douyin: '#111827',
        tiktok: '#111827',
        xiaohongshu: '#ff2442',
        xhs: '#ff2442',
        redbook: '#ff2442',
        kuaishou: '#ff6a00',
        ks: '#ff6a00',
        weibo: '#ff8200',
        bilibili: '#00aeec',
        bilili: '#00aeec',
        b站: '#00aeec',
        shipinhao: '#07c160',
        wx_video: '#07c160',
        package: '#6b5cff',
        抖音: '#111827',
        小红书: '#ff2442',
        快手: '#ff6a00',
        微博: '#ff8200',
        视频号: '#07c160'
      }
      return colorMap[platformKey] || '#ff3176'
    },
    getPlatformStyle(platform) {
      const color = platform.color || this.getPlatformThemeColor(platform)
      return {
        '--platform-color': color,
        '--platform-bg': this.hexToRgba(color, 0.08),
        '--platform-border': this.hexToRgba(color, 0.24)
      }
    },
    hexToRgba(color, opacity) {
      if (!/^#[0-9a-f]{6}$/i.test(color)) {
        return color
      }
      const r = parseInt(color.slice(1, 3), 16)
      const g = parseInt(color.slice(3, 5), 16)
      const b = parseInt(color.slice(5, 7), 16)
      return `rgba(${r}, ${g}, ${b}, ${opacity})`
    },
    clickShare(id) {
      const shareContent = document.getElementById(id) // 需要绘制的部分的 (原生）dom 对象 ，注意容器的宽度不要使用百分比，使用固定宽度，避免缩放问题
      html2canvas(shareContent).then(canvas => {
        this.imgUrl = canvas.toDataURL('image/png')
        if (this.imgUrl !== '') {
          this.dialogImageVisible = true
          this.loading = false
        }
      })
    },
    downs() {
      const alink = document.createElement('a')
      alink.href = this.imgUrl
      alink.download = this.btnTitle //图片名
      alink.click()
    },
    closefn() {
      this.clickfn = true//显示
      this.dialogImageVisible = false
    },
    copyDataRow(id) {
      this.downFrom.list = []
      if (id === 'shareContent') {
        this.copyInner()
        this.copyProduct()
        this.downFrom.shareContentData = this.downFrom.list.join(`\n`)
      } else {
        this.copyOutside()
        this.downFrom.share2ContentData = this.downFrom.list.join(`\n`)
      }
      // console.log(this.downFrom.list.join(`\n`))
    },
    copyInner() {
      const _this = this
      _this.downFrom.list.push('基本信息(内)')
      this.downFrom.inner.map(function(item) {
        switch (item.field) {
          case 'intentions':
            if (_this.infoData.type === 1) {
              if (_this.infoData[item.field].length > 0) {
                const cArr = []
                _this.infoData[item.field].map(function(i) {
                  cArr.push(i.nickname)
                })
                _this.downFrom.list.push(item.label + '：' + cArr.join('、'))
              } else {
                _this.downFrom.list.push(item.label + '：暂无意向达人')
              }
            }
            break
          case 'brand':
            _this.downFrom.list.push(item.label + '：' + (_this.infoData[item.field] ?? '暂无') + '(是否寄回：' + (Number(_this.infoData.is_send_back) === 1 ? '是' : '否') + ')')
            break
          case 'group':
            _this.downFrom.list.push(item.label + '：' + (_this.infoData[item.field]?.display_name ?? '暂无'))
            break
          case 'infoPlatforms':
            if (_this.infoPlatforms && _this.infoPlatforms.length > 0){
              const cArr = []
              _this.infoPlatforms.map(function(i) {
                cArr.push(i.name)
              })
              _this.downFrom.list.push(item.label + '：' + cArr.join('、'))
            } else {
              _this.downFrom.list.push(item.label + '：')
            }
            break
          case 'brand_intro':
            _this.downFrom.list.push(item.label + '：' + (_this.infoData && _this.infoData[item.field] ? _this.infoData[item.field] : '暂无'))
            break
          case 'coop':
            if (_this.infoData.type === 1) {
              _this.downFrom.list.push(item.label + '：' + (_this.infoData?.coop?.display_name));
            }
            break
          case 'is_platform_pay':
            _this.downFrom.list.push(item.label + '：' + (_this.infoData[item.field] === 1 ? '是' : '否' || '暂无'))
            break
          case 'is_policy':
            _this.downFrom.list.push(item.label + '：' + (_this.infoData[item.field] === 1 ? '有' : '无' || '') + '/' + (_this.infoData.policy || '暂无政策'))
            break
          case 'auth_platform_alias':
            if (_this.infoData && _this.infoData[item.field] && _this.infoData[item.field].length > 0){
              const cArr = []
              _this.infoData[item.field].map(function(i) {
                cArr.push(i)
              })
              _this.downFrom.list.push(item.label + '：' + cArr.join('、'))
            } else {
              _this.downFrom.list.push(item.label + '：')
            }
            break
          case 'schedule_date':
            _this.downFrom.list.push(item.label + '：' + _this.infoData?.expect_start + ' 至 ' + _this.infoData?.except_end)
            break
          case 'enroll_date':
            _this.downFrom.list.push(item.label + '：' + _this.infoData?.apply_start.slice(0, 10) + ' 至 ' + _this.infoData?.apply_end.slice(0, 10))
            break
          case 'create_user':
            _this.downFrom.list.push(item.label + '：' + _this.infoData?.create_user?.nickname || '暂无')
            break
          default:
            _this.downFrom.list.push(item.label + '：' + (_this.infoData && _this.infoData[item.field] ? _this.infoData[item.field] : ''))
            break
        }
      })
    },
    copyProduct() {
      const _this = this
      _this.downFrom.list.push('产品信息')
      if (_this.infoData && _this.infoData.product_list && _this.infoData.product_list.length > 0) {
        _this.infoData.product_list.map(function(p_info) {
          _this.downFrom.product.map(function(item) {
            switch (item.field) {
              case 'is_quantity':
                _this.downFrom.list.push(item.label + '：' + (Number(p_info.is_quantity) === 1 ? '是' : '否' || '暂无')
                  + (Number(p_info.is_quantity) === 1 ? ('(费比：' + p_info.qty_policy + ', 直播佣金：' + p_info.live_cmn + ')') : ''))
                break
              case 'is_cart':
                if (Number(_this.infoData.type) === 1) {
                  if (Number(p_info.is_cart) === 1) {
                    _this.downFrom.list.push(item.label + '：是' + ('(挂车佣金：' + p_info?.cart_rate + ', 挂车机制：' + (p_info?.cart_mechanism || '') + ')'))
                  } else {
                    _this.downFrom.list.push(item.label + '：否')
                  }
                }
                break
              case 'unify':
                _this.downFrom.list.push(item.label + '：' + (p_info.unify === 1 ? '是' : '否')
                  + (p_info.unify === 2 ? ('(特殊机制说明：' + p_info?.special_remark + ')') : ''))
                break;
              case 'exclusive':
                _this.downFrom.list.push(item.label + '：' + (p_info.exclusive === 1 ? '是' : '否')
                  + (p_info.exclusive === 1 ? ('(独家机制：' + p_info.other_activity + ')') : ''))
                break
              case 'support_value':
                _this.downFrom.list.push(item.label + '：' + (p_info.support_value === 1 ? '是' : '否'))
                break
              default:
                _this.downFrom.list.push(item.label + '：' + (p_info && p_info[item.field] ? p_info[item.field] : ''))
                break
            }
          })
        })
      }
    },
    copyOutside() {
      const _this = this
      _this.downFrom.list.push('基本信息(外)')
      this.downFrom.outside.map(function(item) {
        switch (item.field) {
          case 'company':
            _this.downFrom.list.push(item.label + '：' + _this.infoData.brand);
            break
          case 'brand':
            _this.downFrom.list.push(item.label + '：' + (_this.infoData.brand || '暂无')
              + '(是否寄回：' + (_this.infoData.is_send_back === 1 ? '是' : '否') + ')');
            break
          case 'group':
            _this.downFrom.list.push(item.label + '：' + (_this.infoData[item.field]?.display_name ?? '暂无'))
            break
          case 'brand_intro':
            _this.downFrom.list.push(item.label + '：' + (_this.infoData?.brand_intro ?? '暂无'))
            break
          case 'infoPlatforms':
            if (_this.infoPlatforms && _this.infoPlatforms.length > 0){
              const cArr = []
              _this.infoPlatforms.map(function(i) {
                cArr.push(i.name)
              })
              _this.downFrom.list.push(item.label + '：' + cArr.join('、'))
            } else {
              _this.downFrom.list.push(item.label + '：')
            }
            break
          case 'coop':
            if (_this.infoData.type === 1) {
              _this.downFrom.list.push(item.label + '：' + (_this.infoData?.coop?.display_name));
            }
            break
          case 'product_list':
            if (_this.infoData && _this.infoData[item.field] && _this.infoData[item.field].length > 0){
              const cArr = []
              _this.infoData[item.field].map(function(i) {
                cArr.push(i.product)
              })
              _this.downFrom.list.push(item.label + '：' + cArr.join('、'))
            } else {
              _this.downFrom.list.push(item.label + '：')
            }
            break
          case 'intro':
            break
          case 'schedule_date':
            _this.downFrom.list.push(item.label + '：' + _this.infoData?.expect_start + ' 至 ' + _this.infoData?.except_end)
            break
          default:
            _this.downFrom.list.push(item.label + '：' + (_this.infoData && _this.infoData[item.field] ? _this.infoData[item.field] : ''))
            break
        }
      })
    },
    handleNotice() {
      this.$confirm('确认通知所有报名人?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const id = await this.$api.sendNoticeInquiry({id: this.projectId})
        if (id) {
          this.$message({
            type: 'success',
            message: '已成功发送通知'
          });
        }
        // /inquiry_project/send_notice
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消通知'
        });
      });
    }
  },
  mounted() {
    this.projectId = this.$route.params.id
    this.getInfo()
  }
}
</script>
<style lang="scss" scoped>
.info-overview {
  padding: 16px 18px 18px;
  background: #f3f5fa;
  border-radius: 8px;
}

.info-panel-wrap {
  min-height: 100%;
}

.info-panel {
  min-height: 100%;
  padding: 16px;
  border: 1px solid #e3e8f2;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 7px rgba(16, 24, 40, 0.05);
}

.panel-head,
.collapse-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.panel-head {
  margin-bottom: 14px;
}

.panel-title {
  display: flex;
  align-items: center;
  color: #0f172a;
  font-size: 15px;
  font-weight: 700;
}

.panel-title.small {
  font-size: 14px;
}

.panel-dot {
  width: 9px;
  height: 9px;
  margin-right: 10px;
  border-radius: 50%;
  background: var(--primary);
  box-shadow: 0 0 0 4px rgba(255, 49, 118, 0.13);
}

.muted-dot {
  background: #8b95a8;
  box-shadow: 0 0 0 4px rgba(139, 149, 168, 0.13);
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.info-item,
.product-item {
  min-width: 0;
  padding: 10px 12px;
  border-radius: 6px;
  background: #f8fafc;
}

.info-item.wide,
.product-item.wide {
  grid-column: span 2;
}

.info-item label,
.product-item label {
  display: block;
  margin-bottom: 6px;
  color: #8793a8;
  font-size: 12px;
  line-height: 1;
}

.info-item span,
.product-item span {
  color: #1e293b;
  font-size: 13px;
  line-height: 1.6;
  word-break: break-word;
}

.info-item em,
.product-item em {
  display: block;
  margin-top: 4px;
  color: #b7791f;
  font-size: 12px;
  font-style: normal;
  line-height: 1.45;
}

.text-chip {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  margin: 0 6px 4px 0;
  padding: 0 8px;
  border-radius: 11px;
  background: #fff1f5;
  color: var(--primary) !important;
}

.platform-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.platform-chip {
  height: 32px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #e3e8f2;
  border-radius: 10px;
  background: #fff;
  color: #1f2937;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.platform-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: 0 0 auto;
}

.notice-line {
  margin-top: 12px;
  padding: 9px 12px;
  border-radius: 6px;
  background: #fff7ed;
  color: #c2410c;
  font-size: 12px;
}

.product-collapse {
  margin-top: 14px;
  border-top: 1px solid #edf1f7;
  padding-top: 12px;
}

.collapse-head {
  min-height: 34px;
  padding: 0 2px;
  cursor: pointer;
}

.product-count {
  height: 22px;
  margin-left: 10px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border-radius: 11px;
  background: #edf0f7;
  color: #536174 !important;
  font-size: 12px !important;
  font-weight: 500;
}

.collapse-arrow {
  color: #8d9aaf;
  transition: transform 0.2s ease;
}

.collapse-arrow.open {
  transform: rotate(90deg);
}

.product-list {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.product-card {
  display: flex;
  gap: 14px;
  padding: 12px;
  border: 1px solid #e4e9f2;
  border-radius: 8px;
  background: #fff;
}

.product-main {
  min-width: 0;
  flex: 1;
}

.product-title {
  margin-bottom: 10px;
  color: #0f172a;
  font-size: 14px;
  font-weight: 700;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.product-cover {
  width: 96px;
  height: 96px;
  border-radius: 6px;
  object-fit: contain;
  background: #f8fafc;
  flex: 0 0 auto;
}

.file-link {
  margin-right: 10px;
  color: var(--primary);
  white-space: nowrap;
}

.file-link i {
  margin-right: 3px;
}

.empty-product {
  padding: 18px 0;
  color: #909399;
  text-align: center;
  font-size: 13px;
}

.panel-actions {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

@media (max-width: 1200px) {
  .product-grid {
    grid-template-columns: 1fr;
  }

  .product-item.wide {
    grid-column: span 1;
  }

  .product-card {
    flex-direction: column;
  }

  .product-cover {
    width: 100%;
    height: 140px;
  }
}

@media (max-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr;
  }

  .info-item.wide {
    grid-column: span 1;
  }
}
</style>

